import React, {useContext, useEffect} from 'react';
import numericFunction from "../../../utils/NumericFunction";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import {OrdersSadanContext} from "../OrdersSadanContext";

function DatePickerSelect2(props) {

  const helper = useContext(OrdersSadanContext);
  const setData = helper.setData
  const data = helper.data

  useEffect(() => {
    const todayDate = new Date().toLocaleDateString("fa-IR");
    setData({submitDate: numericFunction.p2e(todayDate.toLocaleString())})
  }, []);

  return (<div>
    <div className={'div__group__input_select mx-2'}>
      <label htmlFor="">
        تاریخ ثبت
      </label>

      <DatePicker
        onChange={(date) => {
          if (date) {
            setData({submitDate: numericFunction.p2e(date.toLocaleString())})
          } else {
            setData({submitDate: ""})
          }
        }}
        calendar={persian}
        placeholder="تاریخ"
        locale={persian_fa}
        value={data.submitDate}
        calendarPosition="bottom-right"
        hideOnScroll
      />


    </div>


  </div>);
}

export default React.memo(DatePickerSelect2);